// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1EQbn","label":"Section_label__3bggU","contentWrap":"Section_contentWrap__1ktFC","footer":"Section_footer__26etM","footerInner":"Section_footerInner__UyzbL"};